import { render, staticRenderFns } from "./SModalNewClientCreator.vue?vue&type=template&id=8c2f9e5a&scoped=true"
import script from "./sModalNewClientCreator.ts?vue&type=script&lang=ts&external"
export * from "./sModalNewClientCreator.ts?vue&type=script&lang=ts&external"
import style0 from "./SModalNewClientCreator.vue?vue&type=style&index=0&id=8c2f9e5a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2f9e5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c2f9e5a')) {
      api.createRecord('8c2f9e5a', component.options)
    } else {
      api.reload('8c2f9e5a', component.options)
    }
    module.hot.accept("./SModalNewClientCreator.vue?vue&type=template&id=8c2f9e5a&scoped=true", function () {
      api.rerender('8c2f9e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-modal-new-client-creator/SModalNewClientCreator.vue"
export default component.exports